import {
  BiBuildings,
  BiHomeAlt,
  BiMoney,
} from "react-icons/bi";
import {
  FaBehance,
  FaDribbble,
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaTwitter,
  FaVimeo,
  FaYoutube,
} from "react-icons/fa";

export const property = [
  {
    id: 1,
    name: "Siloam Apartments",
    location: "Shanzu Mombasa",
    purpose: "Rent",
    number_of_beds: 2,
    contact: "+254 701234567",
    description:
      "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Libero beatae sit voluptas dolorum vel eligendi consectetur alias in veniam nostrum reiciendis cum labore fugiat ut ipsum quidem earum eaque voluptatem enim possimus, est, saepe explicabo. Reiciendis veritatis maiores dolore quidem doloremque obcaecati quis commodi dolorum. Corporis ad provident officia aut iusto ea, voluptatibus architecto debitis pariatur qui! Nisi esse voluptas veniam, quia provident rerum iure quis quasi, odio quos dolores obcaecati nam nostrum nesciunt ipsum similique recusandae? Neque, animi? Voluptates facere rerum labore eos nulla! Ut, nesciunt facere fugit optio quaerat neque id fuga necessitatibus, pariatur eius tenetur? Esse ipsa numquam distinctio vero reprehenderit, libero architecto itaque, optio quibusdam cupiditate cum, deleniti ad. Sapiente, placeat voluptates a recusandae voluptatum cupiditate nulla vel ut. Eveniet eum obcaecati illo saepe, recusandae natus incidunt quas molestias maxime vel? Possimus perspiciatis, repellat maxime molestias quos perferendis! Impedit consectetur natus alias laudantium sunt ipsam nostrum! Eius quasi officiis, labore sunt itaque porro laudantium, suscipit ipsa dicta magni quibusdam totam? Exercitationem doloribus, debitis, eligendi facere odio a nesciunt nam suscipit quia ullam sequi, illum repudiandae! Hic nobis inventore maxime. Explicabo quod inventore excepturi adipisci provident quidem ab doloremque amet nostrum, ullam fugiat debitis eius aspernatur atque.",
    image: "/images/property (25).jpg",
  },
  {
    id: 2,
    name: "Siloam Apartments",
    location: "Shanzu Mombasa",
    price: "450,000",
    purpose: "Rent",
    number_of_beds: 1,
    contact: "+254 701234567",
    description:
      "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Libero beatae sit voluptas dolorum vel eligendi consectetur alias in veniam nostrum reiciendis cum labore fugiat ut ipsum quidem earum eaque voluptatem enim possimus, est, saepe explicabo. Reiciendis veritatis maiores dolore quidem doloremque obcaecati quis commodi dolorum. Corporis ad provident officia aut iusto ea, voluptatibus architecto debitis pariatur qui! Nisi esse voluptas veniam, quia provident rerum iure quis quasi, odio quos dolores obcaecati nam nostrum nesciunt ipsum similique recusandae? Neque, animi? Voluptates facere rerum labore eos nulla! Ut, nesciunt facere fugit optio quaerat neque id fuga necessitatibus, pariatur eius tenetur? Esse ipsa numquam distinctio vero reprehenderit, libero architecto itaque, optio quibusdam cupiditate cum, deleniti ad. Sapiente, placeat voluptates a recusandae voluptatum cupiditate nulla vel ut. Eveniet eum obcaecati illo saepe, recusandae natus incidunt quas molestias maxime vel? Possimus perspiciatis, repellat maxime molestias quos perferendis! Impedit consectetur natus alias laudantium sunt ipsam nostrum! Eius quasi officiis, labore sunt itaque porro laudantium, suscipit ipsa dicta magni quibusdam totam? Exercitationem doloribus, debitis, eligendi facere odio a nesciunt nam suscipit quia ullam sequi, illum repudiandae! Hic nobis inventore maxime. Explicabo quod inventore excepturi adipisci provident quidem ab doloremque amet nostrum, ullam fugiat debitis eius aspernatur atque.",
    image: "/images/property (26).jpg",
  },
  {
    id: 3,
    name: "Siloam Apartments",
    location: "Shanzu Mombasa",
    purpose: "rent",
    number_of_beds: 3,
    contact: "+254 701234567",
    description:
      "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Libero beatae sit voluptas dolorum vel eligendi consectetur alias in veniam nostrum reiciendis cum labore fugiat ut ipsum quidem earum eaque voluptatem enim possimus, est, saepe explicabo. Reiciendis veritatis maiores dolore quidem doloremque obcaecati quis commodi dolorum. Corporis ad provident officia aut iusto ea, voluptatibus architecto debitis pariatur qui! Nisi esse voluptas veniam, quia provident rerum iure quis quasi, odio quos dolores obcaecati nam nostrum nesciunt ipsum similique recusandae? Neque, animi? Voluptates facere rerum labore eos nulla! Ut, nesciunt facere fugit optio quaerat neque id fuga necessitatibus, pariatur eius tenetur? Esse ipsa numquam distinctio vero reprehenderit, libero architecto itaque, optio quibusdam cupiditate cum, deleniti ad. Sapiente, placeat voluptates a recusandae voluptatum cupiditate nulla vel ut. Eveniet eum obcaecati illo saepe, recusandae natus incidunt quas molestias maxime vel? Possimus perspiciatis, repellat maxime molestias quos perferendis! Impedit consectetur natus alias laudantium sunt ipsam nostrum! Eius quasi officiis, labore sunt itaque porro laudantium, suscipit ipsa dicta magni quibusdam totam? Exercitationem doloribus, debitis, eligendi facere odio a nesciunt nam suscipit quia ullam sequi, illum repudiandae! Hic nobis inventore maxime. Explicabo quod inventore excepturi adipisci provident quidem ab doloremque amet nostrum, ullam fugiat debitis eius aspernatur atque.",
    image: "/images/property (27).jpg",
  },
  {
    id: 4,
    name: "Siloam apartments",
    location: "Shanzu Mombasa",
    purpose: "rent",
    number_of_beds: 3,
    contact: "+25701234567",
    description:
      "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Libero beatae sit voluptas dolorum vel eligendi consectetur alias in veniam nostrum reiciendis cum labore fugiat ut ipsum quidem earum eaque voluptatem enim possimus, est, saepe explicabo. Reiciendis veritatis maiores dolore quidem doloremque obcaecati quis commodi dolorum. Corporis ad provident officia aut iusto ea, voluptatibus architecto debitis pariatur qui! Nisi esse voluptas veniam, quia provident rerum iure quis quasi, odio quos dolores obcaecati nam nostrum nesciunt ipsum similique recusandae? Neque, animi? Voluptates facere rerum labore eos nulla! Ut, nesciunt facere fugit optio quaerat neque id fuga necessitatibus, pariatur eius tenetur? Esse ipsa numquam distinctio vero reprehenderit, libero architecto itaque, optio quibusdam cupiditate cum, deleniti ad. Sapiente, placeat voluptates a recusandae voluptatum cupiditate nulla vel ut. Eveniet eum obcaecati illo saepe, recusandae natus incidunt quas molestias maxime vel? Possimus perspiciatis, repellat maxime molestias quos perferendis! Impedit consectetur natus alias laudantium sunt ipsam nostrum! Eius quasi officiis, labore sunt itaque porro laudantium, suscipit ipsa dicta magni quibusdam totam? Exercitationem doloribus, debitis, eligendi facere odio a nesciunt nam suscipit quia ullam sequi, illum repudiandae! Hic nobis inventore maxime. Explicabo quod inventore excepturi adipisci provident quidem ab doloremque amet nostrum, ullam fugiat debitis eius aspernatur atque.",
    image: "/images/property (28).jpg",
  },
  {
    id: 5,
    name: "Siloam apartments",
    location: "Shanzu Mombasa",
    purpose: "rent",
    number_of_beds: 3,
    contact: "+25701234567",
    description:
      "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Libero beatae sit voluptas dolorum vel eligendi consectetur alias in veniam nostrum reiciendis cum labore fugiat ut ipsum quidem earum eaque voluptatem enim possimus, est, saepe explicabo. Reiciendis veritatis maiores dolore quidem doloremque obcaecati quis commodi dolorum. Corporis ad provident officia aut iusto ea, voluptatibus architecto debitis pariatur qui! Nisi esse voluptas veniam, quia provident rerum iure quis quasi, odio quos dolores obcaecati nam nostrum nesciunt ipsum similique recusandae? Neque, animi? Voluptates facere rerum labore eos nulla! Ut, nesciunt facere fugit optio quaerat neque id fuga necessitatibus, pariatur eius tenetur? Esse ipsa numquam distinctio vero reprehenderit, libero architecto itaque, optio quibusdam cupiditate cum, deleniti ad. Sapiente, placeat voluptates a recusandae voluptatum cupiditate nulla vel ut. Eveniet eum obcaecati illo saepe, recusandae natus incidunt quas molestias maxime vel? Possimus perspiciatis, repellat maxime molestias quos perferendis! Impedit consectetur natus alias laudantium sunt ipsam nostrum! Eius quasi officiis, labore sunt itaque porro laudantium, suscipit ipsa dicta magni quibusdam totam? Exercitationem doloribus, debitis, eligendi facere odio a nesciunt nam suscipit quia ullam sequi, illum repudiandae! Hic nobis inventore maxime. Explicabo quod inventore excepturi adipisci provident quidem ab doloremque amet nostrum, ullam fugiat debitis eius aspernatur atque.",
    image: "/images/property (29).jpg",
  },
  {
    id: 6,
    name: "Siloam Apartments",
    location: "Shanzu Mombasa",
    purpose: "rent",
    number_of_beds: 3,
    contact: "+25701234567",
    description:
      "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Libero beatae sit voluptas dolorum vel eligendi consectetur alias in veniam nostrum reiciendis cum labore fugiat ut ipsum quidem earum eaque voluptatem enim possimus, est, saepe explicabo. Reiciendis veritatis maiores dolore quidem doloremque obcaecati quis commodi dolorum. Corporis ad provident officia aut iusto ea, voluptatibus architecto debitis pariatur qui! Nisi esse voluptas veniam, quia provident rerum iure quis quasi, odio quos dolores obcaecati nam nostrum nesciunt ipsum similique recusandae? Neque, animi? Voluptates facere rerum labore eos nulla! Ut, nesciunt facere fugit optio quaerat neque id fuga necessitatibus, pariatur eius tenetur? Esse ipsa numquam distinctio vero reprehenderit, libero architecto itaque, optio quibusdam cupiditate cum, deleniti ad. Sapiente, placeat voluptates a recusandae voluptatum cupiditate nulla vel ut. Eveniet eum obcaecati illo saepe, recusandae natus incidunt quas molestias maxime vel? Possimus perspiciatis, repellat maxime molestias quos perferendis! Impedit consectetur natus alias laudantium sunt ipsam nostrum! Eius quasi officiis, labore sunt itaque porro laudantium, suscipit ipsa dicta magni quibusdam totam? Exercitationem doloribus, debitis, eligendi facere odio a nesciunt nam suscipit quia ullam sequi, illum repudiandae! Hic nobis inventore maxime. Explicabo quod inventore excepturi adipisci provident quidem ab doloremque amet nostrum, ullam fugiat debitis eius aspernatur atque.",
    image: "/images/property (30).jpg",
  },
];

export const teamMembers = [
  {
    id: 1,
    name: "Wendy Janet",
    role: "Real Estate",
    image: "/images/avatar-2.png",
  },
  {
    id: 2,
    name: "Janie",
    role: "Admin",
    image: "/images/avatar-2.png",
  },
  /* {
    id: 3,
    name: "John Doe",
    role: "Sales",
    image: "/images/avatar-1.png",
  },
  {
    id: 4,
    name: "Jane Doe",
    role: "Marketing",
    image: "/images/avatar-2.png",
  }, */
];


export const focus = [
  {
    id: 1,
    name: "Rent a house",
    icon: <BiHomeAlt />,
    text: "Find the best suited residence for you and your family.",
  },
  {
    id: 2,
    name: "Money value",
    icon: <BiMoney />,
    text: "Prices are moderate and considerate.",
  },
  {
    id: 4,
    name: "Luxury redefined",
    icon: <BiBuildings />,
    text: "Experience the best furniture for your comfort in our apartments.",
  },
];





export const socials = [
  <FaFacebook />,
  <FaTwitter />,
  <FaInstagram />,
  <FaLinkedin />,
  <FaBehance />,
  <FaDribbble />,
  <FaYoutube />,
  <FaVimeo />,
];


export const faqs = [
  {
    id: 1,
    question: "Where are we located?",
    response:
      "We are Located at Shanzu Mombasa",
  },
  {
    id: 2,
    question: "What units are available?",
    response:
      "We have 1, 2 & 3 bedroomed apartments.",
  },
  {
    id: 3,
    question: "What features are available?",
    response:
      "The units are fully furnished and have amenities such as water and electricity in constant supply.",
  },
  {
    id: 4,
    question: "How do I get in touch?",
    response:
      "Reach out to us through our contact page and we will get right back.",
  },
];

export const gallery = [
  {
    id: 1,
    image: "/images/gallery.jpg", 
  },
  {
    id: 2,
    image: "/images/property (26).jpg", 
  },
  {
    id: 3,
    image: "/images/gallery-2.jpg", 
  },
  {
    id: 4,
    image: "/images/gallery-3.jpg", 
  },
  {
    id: 5,
    image: "/images/gallery-4.jpg", 
  },
  {
    id: 6,
    image: "/images/gallery-5.jpg", 
  },
  {
    id: 7,
    image: "/images/gallery-6.jpg", 
  },
  {
    id: 8,
    image: "/images/gallery-7.jpg", 
  },
  {
    id: 9,
    image: "/images/gallery-8.jpg", 
  },
  {
    id: 10,
    image: "/images/gallery-9.jpg", 
  },
  {
    id: 11,
    image: "/images/gallery-10.jpg", 
  },
  {
    id: 12,
    image: "/images/gallery-11.jpg", 
  },
  {
    id: 13,
    image: "/images/gallery-12.jpg", 
  },
  {
    id: 14,
    image: "/images/gallery-13.jpg", 
  },
  {
    id: 15,
    image: "/images/gallery-14.jpg", 
  },
  {
    id: 16,
    image: "/images/gallery-15.jpg", 
  },
  {
    id: 17,
    image: "/images/gallery-16.jpg", 
  },
  {
    id: 18,
    image: "/images/gallery-17.jpg", 
  },
  {
    id: 19,
    image: "/images/gallery-18.jpg", 
  },
  {
    id: 20,
    image: "/images/gallery-19.jpg", 
  },
  {
    id: 21,
    image: "/images/gallery-20.jpg", 
  },
  {
    id: 22,
    image: "/images/gallery-21.jpg", 
  },
  {
    id: 23,
    image: "/images/gallery-22.jpg", 
  },
  {
    id: 24,
    image: "/images/gallery-23.jpg", 
  },
  {
    id: 25,
    image: "/images/gallery-24.jpg", 
  },
  {
    id: 26,
    image: "/images/gallery-25.jpg", 
  },
  {
    id: 27,
    image: "/images/gallery-26.jpg", 
  },
  {
    id: 28,
    image: "/images/gallery-27.jpg", 
  },
  {
    id: 29,
    image: "/images/property (17).jpg", 
  },
  {
    id: 30,
    image: "/images/property (30).jpg",
  }, 
];
